@if (loading) {
    <div class="flex justify-center p-8">Lade Spielerdaten...</div>
}

@if (!loading && races.length === 0) {
    <div class="card flex flex-col items-center justify-center gap-3 p-8 text-center">
        <i class="pi pi-user-minus text-4xl text-muted-color"></i>
        <div class="text-xl font-semibold">Keine Renndaten gefunden</div>
        <p class="text-muted-color max-w-30rem">
            Für diesen Spieler liegen noch keine Rennen vor.
        </p>
    </div>
}

@if (!loading && races.length > 0) {
    <div>
        <app-player-hero
            [name]="name"
            [psn]="psn"
            [discord]="discord"
            [avatar]="avatarUrl"
            [controllers]="controllers"
            [controllerId]="controllerId"
            [displayDevice]="displayDevice"
        />

        <app-member-stats
            [numberOfRaces]="numberOfRaces"
            [bestPlacement]="bestPlacement"
            [bestPlacementCircuit]="bestPlacementCircuit"
            [firstRaceDate]="firstRaceDate"
            [numberOfIncidents]="numberOfIncidents"
        />

        <app-member-badges [participations]="participations" [playerId]="numericPlayerId" />

        <app-player-cars [seasonCars]="seasonCars" [loading]="seasonCarsLoading" />

        <app-member-race-history [races]="races" title="Gefahrene Rennen" />

        <app-member-incidents
            [incidents]="myPlayerDetails.player_incidents ?? []"
            [races]="races"
        />
    </div>
}
